module.exports = __webpack_public_path__ + "static/img/jieshu.ce724d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/jieshu.png
// module id = euWi
// module chunks = 24